import { Mapper } from '../../../common/ddd/mapper.base';
import { SentimentReportTypeEnum } from '../../../common/enum/sentiment/sentiment-report-type.enum';
import { ISentimentReportEnum } from '../../../common/enum/sentiment/sentiment-report.enum';
import { SelfSentimentReportTimeSeriesEntity } from '../../../core/domain/entities/sentiment/self-sentiment-report-time-series.entity';
import { SentimentReportScore } from '../../../interface/dtos/sentiment/sentiment-report-score.dto';

export interface ISelfSentimentReportTimeSeriesPersistenceResponse {
  [ISentimentReportEnum.LocalDate]: string;
  [ISentimentReportEnum.ReportType]: string;
  [ISentimentReportEnum.Score]: string;
  [ISentimentReportEnum.Count]: string;
}

export class SelfSentimentReportTimeSeriesMapper
  implements Mapper<SelfSentimentReportTimeSeriesEntity, SentimentReportScore>
{
  toDomain(
    record: ISelfSentimentReportTimeSeriesPersistenceResponse
  ): SelfSentimentReportTimeSeriesEntity {
    return SelfSentimentReportTimeSeriesMapper.toDomain(record);
  }
  static toDomain(
    record: ISelfSentimentReportTimeSeriesPersistenceResponse
  ): SelfSentimentReportTimeSeriesEntity {
    const entity = SelfSentimentReportTimeSeriesEntity.create({
      localDate: new Date(record[ISentimentReportEnum.LocalDate]),
      reportType: record[
        ISentimentReportEnum.ReportType
      ] as SentimentReportTypeEnum,
      score: Number(record[ISentimentReportEnum.Score]),
      count: Number(record[ISentimentReportEnum.Count]),
    });
    return entity;
  }

  toResponse(
    entity: SelfSentimentReportTimeSeriesEntity
  ): SentimentReportScore {
    return SelfSentimentReportTimeSeriesMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfSentimentReportTimeSeriesEntity
  ): SentimentReportScore {
    return {
      date: entity.localDate.toISOString(),
      score: String(entity.score),
      count: entity.count,
      percentageOfTotal: `${entity.percentageOfTotal}`,
      type: entity.reportType,
    };
  }
}
